import React, { createRef } from 'react';
import { View, StyleSheet } from 'react-native';

import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../selectors/entities';
import { findCases } from '../../services/caseService';

import { BENEFICIARY } from '../../constants/patientRoles';

import { OPComponent, SuggestionList, I18n } from '../components';

import SelectedAirman from './selected_airman';
import { EVENT_TYPE_AIRFORCE_DEPLOYMENT as EVENT_TYPE_READINESS } from '../../constants/eventTypes';

const listRef = createRef();

class ResidentSelect extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      caseItems: null,
    };
  }

  prepCaseItems = (cases) => {
    const props = this.props;
    const filteredCases = props.caseFilter ? props.caseFilter(cases) : cases;
    return filteredCases
      .map((c) => {
        if (!this.props.includeBeneficiaries) {
          if (c.patient?.role === BENEFICIARY) return null;
        }
        return {
          label: c.name,
          id: c.caseId,
          item: c,
        };
      })
      .filter((c) => c !== null);
  };

  handleCaseInputChange = ({ value, item }) => {
    this.props.onValueChange();
    if (!item) {
      this._value = value;
      if (!value?.length) {
        listRef.current?.setItems([]);
      } else if (value.length >= 3) {
        if (this._searchTimeoutId) clearTimeout(this._searchTimeoutId);
        this._searchTimeoutId = setTimeout(() => {
          this.handleInputSubmit();
        }, 300);
      }
      return;
    }

    this.props.onSelectCase(item.id, item);
  };

  handleInputSubmit = () => {
    findCases(this.props.employerId, { term: this._value }).then(this.handleSearchResult);
  };
  handleSearchResult = ({ rows }) => {
    listRef.current?.setItems(this.prepCaseItems(rows));
    this.props.onValueChange();
  };

  renderItem = (item) => {
    if (!item || !item.id) return null;

    return <SelectedAirman case={item.item} patient={item.item.patient} hideDeployment={true} />;
  };

  render() {
    const props = this.props;
    const items = props.caseFilter ? props.caseFilter(this.state.caseItems) : this.state.caseItems;
    const readinessEventType = !!(props.eventType === EVENT_TYPE_READINESS);

    return (
      <View style={styles.container} pointerEvents="box-none">
        <View style={styles.suggestionListContainer} pointerEvents="box-none">
          <SuggestionList
            ref={listRef}
            items={items}
            defaultValue={null}
            onValue={this.handleCaseInputChange}
            onSubmit={null}
            placeholderText={
              !readinessEventType
                ? I18n.ac_aec('case.findResident')
                : I18n.ac_aec('case.findServiceMember')
            }
            searchMode={true}
            autoFocus={this.props.autoFocus}
            renderItem={this.renderItem}
            containerStyle={{}}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  suggestionListContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    employerId: getCurrentEmployer(state)?.employerId,
  };
}

export default connect(mapStateToProps, null)(ResidentSelect);
